<template>
  <div class="userCrowd">
    <div class="content">
      <div class="hintHead">
        <span style="font-size:16px">运营计划</span>
        <el-button size="mini" type="text" @click="check"
          >查看全部计划</el-button
        >
      </div>
      <div class="swiper_card_group" v-if="all_Part == 1">
        <swiper :options="swiperOption" class="swiper-box">
          <swiper-slide
            class="swiper-item"
            v-for="(item, index) in pageMethods"
            :key="index"
          >
            <div class="card">
              <div class="recommend-crowd-block__head">
                <div class="title">{{ item.title }}</div>
                <el-tag
                  size="mini"
                  :type="item.color"
                  effect="plain"
                  v-if="item.tag != ''"
                  >{{ item.tag }}</el-tag
                >
              </div>
              <div class="recommend-crowd-block__body">
                {{ item.des }}
              </div>
              <div class="width100">
                <el-button type="primary" size="small" @click="go(index)"
                  >立即新建</el-button
                >
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
      <div class="all_css" v-if="all_Part == 0">
        <div class="all_item" v-for="(item, index) in pageMethods" :key="index">
          <div class="card">
            <div class="recommend-crowd-block__head">
              <div class="title">{{ item.title }}</div>
              <el-tag
                size="mini"
                :type="item.color"
                effect="plain"
                v-if="item.tag != ''"
                >{{ item.tag }}</el-tag
              >
            </div>
            <div class="recommend-crowd-block__body">
              {{ item.des }}
            </div>
            <div class="width100">
              <el-button type="primary" size="small" @click="go(index)"
                >立即新建</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="plan-list-table__container">
        <div class="plan-list-table__empty">
          当前还没有任何计划，快选择人群创建计划吧
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "userCrowd", // 用户分群
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      all_Part: 1, //0 全部 1 部分
      swiperOption: {
        direction: "horizontal",
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
        loop: true,
        loopFillGroupWithBlank: true,
        mousewheel: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      pageMethods: [
        {
          title: "未消费新增客户：0",
          des: "近3个月有浏览店铺，但未进行消费的顾客",
          tag: "获客",
          color: "success"
        },
        {
          title: "兴趣人群转化：0",
          des: "近7天有加购行为，但没有成功付款的客户",
          tag: "获客",
          color: "success"
        },
        {
          title: "互动粉丝转化",
          des: "不受群发条数限制，通过图文智能触达互动粉丝",
          tag: "",
          color: ""
        },
        {
          title: "需重点召回客户：0",
          des: "历史下单数和客单价都高于平均，但近90天未下单",
          tag: "深耕",
          color: "warning"
        },
        {
          title: "需重点发展客户：0",
          des: "不受群发条数限制，通过图文智能触达互动粉丝",
          tag: "深耕",
          color: "warning"
        },
        {
          title: "需重点活跃客户：",
          des: "历史下单数和客单价都高于平均，但近30天未下单",
          tag: "促活",
          color: "danger"
        },
        {
          title: "需刺激消费客户：",
          des: "近30天有过交易记录，下单数低于平均但客单价高于平均",
          tag: "深耕",
          color: "warning"
        },
        {
          title: "自定义人群",
          des: "根据自身经营情况，创建个性化的人群运营计划",
          tag: "",
          color: ""
        },
        {
          title: "指定手机号客户",
          des: "指定手机号，精准定位客户",
          tag: "",
          color: ""
        }
      ]
    };
  },
  methods: {
    // 切换显示
    check() {
      this.all_Part = !this.all_Part;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 跳转
    go(index) {
      this.$router.push(`addCrowdOperat?type=${index}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.userCrowd {
  min-height: 600px;
  margin: 16px;
  background: #fff;
  .content {
    padding: 16px;
    .hintHead {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 15px;
    }
    .swiper_card_group {
      .swiper-box {
        width: 100%;
        height: 100%;
        margin: 0 auto;
      }
      .swiper-item {
        height: 100%;
        text-align: center;
        font-size: 18px;
        background: #fff;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }
    }
    .card {
      width: 99%;
      min-height: 140px;
      margin: 0 10px 16px 0;
      padding: 20px 15px 16px 16px;
      display: flex;
      flex-direction: column;
      background: #edf4ff;
      .recommend-crowd-block__head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 15px;
        .title {
          font-size: 16px;
          font-weight: 700;
          line-height: 16px;
        }
      }
      .recommend-crowd-block__body {
        text-align: left;
        font-size: 14px;
        color: #7d7e80;
        margin-bottom: 15px;
      }
      .width100 {
        text-align: left;
      }
    }
    .plan-list-table__container {
      margin-bottom: 20px;
      min-height: 200px;
      .plan-list-table__empty {
        border: 1px solid #ebedf0;
        height: 80px;
        line-height: 80px;
        text-align: center;
      }
    }
  }
}
//
.all_css {
  display: flex;
  flex-wrap: wrap;
  .all_item {
    width: 33%;
  }
}
.swiper-button-next {
  width: 24px;
  height: 24px;
  background: url("../../../../public/img/nextButton.png");
  background-size: 24px 24px;
  background-repeat: no-repeat;
}
.swiper-button-prev {
  background: url("../../../../public/img/prev.png");
  background-size: 24px 24px;
  background-repeat: no-repeat;
}
</style>

<style lang="scss">
.userCrowd {
  .el-table th,
  .el-table tr {
    background: #f2f2f2;
  }
}
</style>
